import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["children", "hideBorder"];
import { H4 } from '@atlassian/mpac-primitives';
import * as React from 'react';
import { HeadingWrapper } from './styles';
export const Heading = props => {
  const {
      children,
      hideBorder = false
    } = props,
    otherProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(HeadingWrapper, {
    $bottomBorder: !hideBorder
  }, /*#__PURE__*/React.createElement(H4, _extends({
    as: "h3"
  }, otherProps), children));
};